(function () {
    'use strict';

    angular
        .module('bhsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('bhs', {
            parent: 'app',
            abstract: true,
            data: {
                authorities: []
            },
            views: {
                'content': {
                    templateUrl: 'app/bhs/bhs.html',
                    controller: 'BhsController',
                    controllerAs: 'vm'
                }           
            }
        });
    }
})();
